import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import s from './Stat.scss';
const shorten = (number)=>shortenNumber(number, 0, Math.floor);
const Stat = ({ deviation , onlyNumbers: showOnlyNumbers , statNameLocaleKey , statCount =0 , userListType , biData , dataHook , tooltipDataHook , className , icon: Icon , onClick  })=>{
    const { t  } = useTranslation();
    const onlyNumbers = !statNameLocaleKey || showOnlyNumbers;
    const hasTooltip = userListType && deviation;
    const iconAndStat = /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        className: s['stat-button'],
        biData: biData,
        onClick: onClick
    }, onClick ? {
        style: {
            cursor: 'pointer'
        }
    } : {
        tabIndex: -1
    }, {
        isFakeButton: !onClick
    }), Icon && /*#__PURE__*/ React.createElement(Icon, {
        className: s['stat-icon'],
        size: IconSize.SMALL,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['stat-text']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['stat-count']
    }, shorten(statCount)), ' ', /*#__PURE__*/ React.createElement("span", {
        className: s['stat-name']
    }, statCount === 1 ? t(`${statNameLocaleKey}_one`) : t(`${statNameLocaleKey}_other`))));
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['stat'], hasTooltip && s['has-tooltip'], onlyNumbers && s['only-numbers'], className)
    }, userListType && deviation ? // TODO: there should be a way to open these with the keyboard
    /*#__PURE__*/ React.createElement(WhoTooltipWrapper, {
        deviation: deviation,
        userListType: userListType,
        dataHook: dataHook,
        tooltipDataHook: tooltipDataHook
    }, iconAndStat) : iconAndStat);
};
Stat.displayName = 'Stat';
export default Stat;
